/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsFilter } from './ContactDetailsFilter';
import {
    ContactDetailsFilterFromJSON,
    ContactDetailsFilterFromJSONTyped,
    ContactDetailsFilterToJSON,
} from './ContactDetailsFilter';

/**
 * Extends inputs for "list" type operations to accept pagination details
 * @export
 * @interface GetCallibrationDataWithFiltersRequestContent
 */
export interface GetCallibrationDataWithFiltersRequestContent {
    /**
     * Return analytics on contacts created before this timestamp
     * @type {string}
     * @memberof GetCallibrationDataWithFiltersRequestContent
     */
    from?: string;
    /**
     * Return analytics on contacts after this timestamp
     * @type {string}
     * @memberof GetCallibrationDataWithFiltersRequestContent
     */
    to?: string;
    /**
     * 
     * @type {Array<ContactDetailsFilter>}
     * @memberof GetCallibrationDataWithFiltersRequestContent
     */
    filters?: Array<ContactDetailsFilter>;
}


/**
 * Check if a given object implements the GetCallibrationDataWithFiltersRequestContent interface.
 */
export function instanceOfGetCallibrationDataWithFiltersRequestContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetCallibrationDataWithFiltersRequestContentFromJSON(json: any): GetCallibrationDataWithFiltersRequestContent {
    return GetCallibrationDataWithFiltersRequestContentFromJSONTyped(json, false);
}

export function GetCallibrationDataWithFiltersRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCallibrationDataWithFiltersRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(ContactDetailsFilterFromJSON)),
    };
}

export function GetCallibrationDataWithFiltersRequestContentToJSON(value?: GetCallibrationDataWithFiltersRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(ContactDetailsFilterToJSON)),
    };
}

